import WhatsappAppTemplatesAPI from '../../api/whatsappAppTemplates';
import { throwErrorMessage } from '../utils/api';

export const state = {
  templates: [],
  currentTemplate: null,
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isSending: false,
  },
};

export const getters = {
  getTemplates($state) {
    return $state.templates;
  },
  getCurrentTemplate($state) {
    return $state.currentTemplate;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await WhatsappAppTemplatesAPI.getAll();
      commit('SET_TEMPLATES', data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, templateData) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await WhatsappAppTemplatesAPI.create(templateData);
      commit('ADD_TEMPLATE', data);
      return data;
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, ...templateData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await WhatsappAppTemplatesAPI.update(id, templateData);
      commit('UPDATE_TEMPLATE', data);
      return data;
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await WhatsappAppTemplatesAPI.delete(id);
      commit('REMOVE_TEMPLATE', id);
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  async testSend(
    { commit },
    {
      id,
      contact_phone,
      placeholder_values,
      content,
      interactive_config,
      inbox_id,
    }
  ) {
    commit('SET_UI_FLAG', { isSending: true });
    try {
      const { data } = await WhatsappAppTemplatesAPI.testSend(id, {
        contact_phone,
        placeholder_values,
        content,
        interactive_config,
        inbox_id,
      });
      return data;
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isSending: false });
    }
  },

  setCurrentTemplate({ commit }, template) {
    commit('SET_CURRENT_TEMPLATE', template);
  },
};

export const mutations = {
  SET_TEMPLATES($state, templates) {
    $state.templates = templates;
  },
  ADD_TEMPLATE($state, template) {
    // Substituir o array (nova referência) para garantir reatividade em componentes KeepAlive
    $state.templates = [template, ...$state.templates];
  },
  UPDATE_TEMPLATE($state, updatedTemplate) {
    const index = $state.templates.findIndex(t => t.id === updatedTemplate.id);
    if (index !== -1) {
      $state.templates.splice(index, 1, updatedTemplate);
    }
    if ($state.currentTemplate?.id === updatedTemplate.id) {
      $state.currentTemplate = updatedTemplate;
    }
  },
  REMOVE_TEMPLATE($state, id) {
    $state.templates = $state.templates.filter(t => t.id !== id);
    if ($state.currentTemplate?.id === id) {
      $state.currentTemplate = null;
    }
  },
  SET_CURRENT_TEMPLATE($state, template) {
    $state.currentTemplate = template;
  },
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
